import './TutorialGirl.css';

function TutorialGirl({position = 'Left', undressingProcess = 1}) {


    return <div className={'tutorialGirl tutorialGirl_' + undressingProcess + ' tutorialGirl' + position}>
    </div>
}

export default TutorialGirl;